import api from 'api';
import {
  dashboardMetaDesignsAsyncActionSuccess,
} from 'actions/dashboard';

export const DESIGNS_ASYNC_ACTION_START = 'DESIGNS_ASYNC_ACTION_START';
export const DESIGNS_ASYNC_ACTION_SUCCESS = 'DESIGNS_ASYNC_ACTION_SUCCESS';
export const DESIGNS_ASYNC_ACTION_ERROR = 'DESIGNS_ASYNC_ACTION_ERROR';
export const DESIGNS_UPDATE_FILTERS = 'DESIGNS_UPDATE_FILTERS';
export const DESIGNS_DRAGGABLE_UPDATE = 'DESIGNS_DRAGGABLE_UPDATE';
export const DESIGNS_RESET_STATE = 'DESIGNS_RESET_STATE';
export const DESIGNS_ORDINALS_DEBOUNCE = 'DESIGNS_ORDINALS_DEBOUNCE';
export const DESIGNS_SET_DUPDESIGNID = 'DESIGNS_SET_DUPDESIGNID';
export const DESIGNS_ADD_DESIGN = 'DESIGNS_ADD_DESIGN';

function designsAsyncActionStart() {
  return {
    type: DESIGNS_ASYNC_ACTION_START,
  };
}

function designsAsyncActionSuccess(data) {
  return {
    type: DESIGNS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function designsAsyncActionError(error) {
  return {
    type: DESIGNS_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetDesignsState() {
  return {
    type: DESIGNS_RESET_STATE,
  };
}

export function designsUpdateFilters(key, value) {
  return {
    type: DESIGNS_UPDATE_FILTERS,
    key,
    value,
  };
}

export function updateDraggableDesigns(data) {
  return {
    type: DESIGNS_DRAGGABLE_UPDATE,
    data,
  };
}

export function setDuplicatedDesignId(data) {
  return {
    type: DESIGNS_SET_DUPDESIGNID,
    data,
  };
}

export const addDesignToDesigns = (design) => {
  return {
    type: DESIGNS_ADD_DESIGN,
    data: design,
  };
};

export function getDesignsAsync(menuType = '') {
  return (dispatch, getState) => {

    dispatch(designsAsyncActionStart());
    return api.request(`design/designlist?menuType=${ menuType }`, 'get')
    .then((data) => {
      dispatch(designsAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(designsAsyncActionError('Unable to get designs'));
      throw (err);
    });
  };
}

export function updateDesignsOrdinal(orderedDesigns) {
  const thunk = (dispatch, getState) => {
    
    return api.request('design/updateOrdinalsByIndex', 'put', orderedDesigns)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      dispatch(designsAsyncActionError('Unable to order Designs'));
      throw (err);
    });
  };
  thunk.meta = {
    debounce: {
      time: 500,
      key: DESIGNS_ORDINALS_DEBOUNCE,
    },
  };
  return thunk;
}

export function getDesignsCount() {
  return (dispatch, getState) => {
    
    return api.request('design/count', 'get')
    .then((data) => {
      dispatch(dashboardMetaDesignsAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(designsAsyncActionError('Unable to get desings count'));
      throw (err);
    });
  };
}

export function duplicateDesignAsync(id) {
  return (dispatch, getState) => {
    dispatch(designsAsyncActionStart());
    return api.request(`design/duplicateDesign?id=${ id }`, 'post')
    .then((data) => {
      dispatch(designsAsyncActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(designsAsyncActionError('Unable to duplicate design'));
      throw (err);
    });
  };
}

export function duplicateBuzzcardAsync(id) {
  return (dispatch, getState) => {
    dispatch(designsAsyncActionStart());
    return api.request(`design/duplicateBuzzcard?id=${ id }`, 'post')
    .then((data) => {
      dispatch(designsAsyncActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(designsAsyncActionError('Unable to duplicate buzzcard design'));
      throw (err);
    });
  };
}

export function duplicatePosterAsync(id) {
  return (dispatch, getState) => {
    dispatch(designsAsyncActionStart());
    return api.request(`design/duplicatePoster?id=${ id }`, 'post')
    .then((data) => {
      dispatch(designsAsyncActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(designsAsyncActionError('Unable to duplicate Poster design'));
      throw (err);
    });
  };
}
